import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { StarFilled } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import { DistanceFromVenue } from '@shared/components/DistanceFromVenue';
import { TILE_RATING_BADGE_SIZE, TILE_RATING_BADGE_BORDER_RADIUS } from '../HotelTile.constants';
import type { MetadataProps } from '../HotelTile.types';

export const Metadata: React.FC<MetadataProps> = React.memo(({ rating, distance }) => {
  const ratingScore = rating?.score;
  const starCount = rating?.starCount ?? 0;
  const hasDistance = distance?.miles != null || distance?.distances != null;

  if (ratingScore == null && !hasDistance && starCount === 0) return null;

  return (
    <Flex
      gap={3}
      alignItems="center"
      flexWrap="wrap"
    >
      {ratingScore != null && (
        <Flex
          alignItems="center"
          justifyContent="center"
          width={pxToRem(TILE_RATING_BADGE_SIZE)}
          height={pxToRem(TILE_RATING_BADGE_SIZE)}
          backgroundColor="mono2"
          borderRadius={pxToRem(TILE_RATING_BADGE_BORDER_RADIUS)}
          flexShrink={0}
        >
          <TextV2
            typographyVariant="label1"
            color="mono12"
          >
            {ratingScore.toFixed(1)}
          </TextV2>
        </Flex>
      )}
      {hasDistance && (
        <DistanceFromVenue
          distances={distance?.distances}
          milesToVenue={distance?.miles}
          size="sm"
          useShortWording
        />
      )}
      {starCount > 0 && (
        <Flex
          gap="2px"
          alignItems="center"
        >
          {Array.from({ length: starCount }).map((_, i) => (
            <StarFilled
              key={i}
              size={16}
            />
          ))}
        </Flex>
      )}
    </Flex>
  );
});

Metadata.displayName = 'HotelTile.Metadata';
